import { render, staticRenderFns } from "./SkillAssignDetail.vue?vue&type=template&id=f5f9bcc2"
import script from "./SkillAssignDetail.vue?vue&type=script&lang=js"
export * from "./SkillAssignDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports